<template>
  <div class="datatableWrapper">
    <div class="datatableWrapperInner">
      <div class="row form-group">
        <div class="col col-sm-6">
          <div class="row">
            <div class="colx text-right pl20" style="">
              <label for="select" class=" form-control-label">{{ $t('TableDatatableJs.search') }}</label>
            </div>
            <div class="col col-6 input-group">
              <InputText style="flex: 1 1 0;" hasToKeyboard="auto" id="text-input" v-model="searchText" title="" placeholder="" dataLayout="t" className="form-control w100i d-block"/>
              <!--<input v-model="searchText" type="text" id="text-input" name="searchText" placeholder="" class="form-control">-->
              <span v-on:click="(searchText='')" class="input-group-addon cursor"><i class="fa fa-times"></i></span>
            </div>
          </div>
        </div>
        <div class="col col-sm-6">
          <div class="row">
            <div class="col col-5 text-right ">
              <label for="text-input" class=" form-control-label">{{ $t('TableDatatableJs.perpage') }}</label>
            </div>
            <div class="col col-7 ">
              <select id="select" class="form-control" v-model="perPageStr" name="perPageStr">
                <option value="3">3</option>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-xl-5 pl10">
          <div class="dataTables_info" role="status"
               aria-live="polite">{{$t('TableDatatableJs.countMaxPageText')}}:  {{this.data.length}} ({{((this.actualPage * this.perPage) - this.perPage)}} - {{(this.actualPage * this.perPage)}})
          </div>
        </div>
        <div class="col-lg-12 col-xl-7 ">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li v-on:click="prev()" class="paginate_button page-item previous "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0"
                                                                                     class="page-link">{{$t('TableDatatableJs.prev')}}</a></li>
              <li v-on:click="setActualPage(actualPage - 500)" v-if="(this.actualPage>500)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                  aria-controls="bootstrap-data-table"
                                                                                                                                                  data-dt-idx="1" tabindex="0"
                                                                                                                                                  class="page-link">{{(this.actualPage > 500) ? (this.actualPage - 500) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 50)" v-if="(this.actualPage>50)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)" aria-controls="bootstrap-data-table"
                                                                                                                                                data-dt-idx="1" tabindex="0"
                                                                                                                                                class="page-link">{{(this.actualPage > 50) ? (this.actualPage - 50) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 3)" v-if="(this.actualPage>3)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="1"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 3) ? (this.actualPage - 3) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 2)" v-if="(this.actualPage>2)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="2"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 2) ? (this.actualPage - 2) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 1)" v-if="(this.actualPage>1)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="3"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 1) ? (this.actualPage - 1) : ""}}</a>
              </li>
              <li v-if="(true)" class="paginate_button page-item active"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="4" tabindex="0"
                                                                            class="page-link">{{this.actualPage}}</a></li>
              <li v-on:click="setActualPage(actualPage + 1)" v-if="((this.actualPage < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                  aria-controls="bootstrap-data-table"
                                                                                                                                                  data-dt-idx="5" tabindex="0"
                                                                                                                                                  class="page-link">{{(this.actualPage < this.countMaxPage) ? (this.actualPage + 1) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 2)" v-if="((this.actualPage+1 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="6" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage + 1 < this.countMaxPage) ? (this.actualPage + 2) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 3)" v-if="((this.actualPage+2 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="6" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage + 2 < this.countMaxPage) ? (this.actualPage + 3) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 50)" v-if="((this.actualPage+50 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                      aria-controls="bootstrap-data-table"
                                                                                                                                                                      data-dt-idx="6" tabindex="0"
                                                                                                                                                                      class="page-link">{{(this.actualPage + 50 < this.countMaxPage) ? (this.actualPage + 51) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 500)" v-if="((this.actualPage+500 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                        aria-controls="bootstrap-data-table"
                                                                                                                                                                        data-dt-idx="6" tabindex="0"
                                                                                                                                                                        class="page-link">{{(this.actualPage + 500 < this.countMaxPage) ? (this.actualPage + 501) : ""}}</a>
              </li>
              <li v-on:click="next()" class="paginate_button page-item next"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0"
                                                                                class="page-link">{{$t('TableDatatableJs.next')}}</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="dataTableContent">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col" v-for="(headRow, index) in headWithFilter" v-on:click="headRowClick(headRow, index)" class="cursor">
              <i v-bind:class="{
                            'fa fa-sort-asc':(headRow.sortDirection==='asc'),
                         'fa fa-sort-desc':(headRow.sortDirection==='desc'),
                         'fa fa-sort':(typeof headRow.sortDirection==='undefined')
                        }"></i>
              {{$t(headRow.title)}}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(dataRow, index) in dataRange(((this.actualPage*this.perPage)-this.perPage), this.perPage)">
            <td v-for="(headRow, index) in head" :style="headRow.styletd" :class="(headRow.cbclasstd)?headRow.cbclasstd(dataRow[headRow.key], 'type', dataRow, 'meta'):headRow.classtd">
              <template v-if="headRow.linkurl">
                <span :style="headRow.styletext" :class="headRow.classtext"><router-link :to="{ path: headRow.linkurl+'/'+dataRow.id}" :class="headRow.linkclass"><i
                  :class="headRow.linkiconclass"></i> {{$t(headRow.linktext)}}</router-link></span>
              </template>
              <template v-if="headRow.linkfn">
                            <span :style="headRow.styletext" :class="headRow.classtext"><a href="javascript:void 0;" v-on:click="function g(e){headRow.linkfn(e,dataRow[headRow.key],'type',dataRow,'meta')}"
                                                                                           :class="headRow.linkclass"><i :class="headRow.linkiconclass"></i>
                                {{$t(headRow.linktext)}}</a></span>
              </template>
              <!--<template v-if="headRow.render">-->
              <!--XX{{headRow.render(dataRow[headRow.key], "??type", headRow, "??meta")}}-->
              <!--</template>-->

              <template v-if="!headRow.linkfn&&!headRow.linkurl">

                <template v-if="!headRow.render">
                  <template v-if="!headRow.i18Key">
                    <span :style="headRow.styletext" :class="headRow.classtext">{{dataRow[headRow.key]}}</span>
                  </template>
                  <template v-if="headRow.i18Key">
                    <span :style="headRow.styletext" :class="headRow.classtext">{{$t(headRow.i18Key + "." + dataRow[headRow.key]) }}</span>
                  </template>
                </template>
                <template v-if="headRow.render">
                  <template>
                    <span :style="headRow.styletext" :class="headRow.classtext">{{headRow.render(dataRow[headRow.key], "type", dataRow, "meta")}}</span>
                  </template>

                </template>

              </template>

            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="col-lg-12 col-xl-5">
          <div class="dataTables_info" role="status"
               aria-live="polite">{{$t('TableDatatableJs.countMaxPageText')}}:  {{this.data.length}} ({{((this.actualPage * this.perPage) - this.perPage)}} - {{(this.actualPage * this.perPage)}})
          </div>
        </div>
        <div class="col-lg-12 col-xl-7">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li v-on:click="prev()" class="paginate_button page-item previous "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0"
                                                                                     class="page-link">{{$t('TableDatatableJs.prev')}}</a></li>
              <li v-on:click="setActualPage(actualPage - 500)" v-if="(this.actualPage>500)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                  aria-controls="bootstrap-data-table"
                                                                                                                                                  data-dt-idx="1" tabindex="0"
                                                                                                                                                  class="page-link">{{(this.actualPage > 500) ? (this.actualPage - 500) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 50)" v-if="(this.actualPage>50)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)" aria-controls="bootstrap-data-table"
                                                                                                                                                data-dt-idx="1" tabindex="0"
                                                                                                                                                class="page-link">{{(this.actualPage > 50) ? (this.actualPage - 50) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 3)" v-if="(this.actualPage>3)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="1"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 3) ? (this.actualPage - 3) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 2)" v-if="(this.actualPage>2)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="2"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 2) ? (this.actualPage - 2) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 1)" v-if="(this.actualPage>1)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="3"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 1) ? (this.actualPage - 1) : ""}}</a>
              </li>
              <li v-if="(true)" class="paginate_button page-item active"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="4" tabindex="0"
                                                                            class="page-link">{{this.actualPage}}</a></li>
              <li v-on:click="setActualPage(actualPage + 1)" v-if="((this.actualPage < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                  aria-controls="bootstrap-data-table"
                                                                                                                                                  data-dt-idx="5" tabindex="0"
                                                                                                                                                  class="page-link">{{(this.actualPage < this.countMaxPage) ? (this.actualPage + 1) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 2)" v-if="((this.actualPage+1 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="6" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage + 1 < this.countMaxPage) ? (this.actualPage + 2) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 3)" v-if="((this.actualPage+2 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="6" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage + 2 < this.countMaxPage) ? (this.actualPage + 3) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 50)" v-if="((this.actualPage+50 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                      aria-controls="bootstrap-data-table"
                                                                                                                                                                      data-dt-idx="6" tabindex="0"
                                                                                                                                                                      class="page-link">{{(this.actualPage + 50 < this.countMaxPage) ? (this.actualPage + 51) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 500)" v-if="((this.actualPage+500 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                        aria-controls="bootstrap-data-table"
                                                                                                                                                                        data-dt-idx="6" tabindex="0"
                                                                                                                                                                        class="page-link">{{(this.actualPage + 500 < this.countMaxPage) ? (this.actualPage + 501) : ""}}</a>
              </li>
              <li v-on:click="next()" class="paginate_button page-item next"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0"
                                                                                class="page-link">{{$t('TableDatatableJs.next')}}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="">-->
      <!--<button type="submit" class="btn btn-primary btn-sm" v-on:click="dataexport">-->
        <!--<i class="fa fa-save"></i> {{$t('global.save')}}-->
      <!--</button>-->
    <!--</div>-->

  </div>
</template>
<script>
  import InputText from '@/components/InputText.vue';

  /**
   * The data and head Arrays are more or less same as jquery datatable params
   *
   * Here is an example. It uses link, and i18 translate too
   *
   data: [{"id": "1", "user_name": "value"}, {"id": "2", "user_name": "value2"}],
   head: [
   {
     title: "users.dttitle" ,
     data: "id",
     link: true,
     linkurl: "useredit",
     linkiconclass: "menu-icon fa fa-edit",
     linktext: "users.linktext",
   },
   {
     key: "user_name",
     title: "Title"
   }
   ,{
      key: "user_role",
      title: "Jogkör",
      i18Key:"user_role"
    }
   ]
   *
   */
  export default {
    name: 'TableDatatableJs',
    props: {
      data: Array, // Array of object - Key, value pair
      head: Array, // Array of object - Key, value contains head property
    },
    data(){
      return {
        searchText: "",
        perPage: 5,
        perPageStr: "5",
        actualPage: 1,
        countMaxPage: 0,
        dataFiltered: [],
        headWithFilter: []
      }
    },
    mounted() {
      const modul = this;
      modul.dataFiltered = modul.data;
      modul.headWithFilter = modul.head;
      /*      const moduldata=[];
       Array.prototype.forEach.call(modul.data, function (e, i) {
       moduldata.push(e);
       });
       modul.dataFiltered = moduldata;
       const modulhead=[];
       Array.prototype.forEach.call(modul.head, function (e, i) {
       modulhead.push(e);
       });
       modul.headWithFilter = modulhead;*/
    },
    watch: {
      data: function (newdata, olddata) {
        const modul = this;
        modul.dataFiltered = newdata;
      },
      searchText: function (newdata, olddata) {
        const modul = this;
        if (modul.searchText.length > 0) {
          let data = [];
          Array.prototype.forEach.call(modul.data, function (e, i) {
            let vanbenne = false;
            for (let i2 in modul.data[i]) {
              if (!modul.data[i].hasOwnProperty(i2)) {
                continue;
              }
              if (modul.data[i][i2] && modul.data[i][i2].search && modul.data[i][i2].toLowerCase().indexOf(modul.searchText.toLowerCase()) >= 0) {
                vanbenne = true;
              }
            }
            if (vanbenne === true) {
              data.push(modul.data[i])
            }
          });
          modul.dataFiltered = data;
        } else {
          modul.dataFiltered = modul.data;
        }
      },
      dataFiltered: function (newdata, olddata) {
        if (newdata !== olddata) {
          this.calculateCountPage();
        }
        if (this.actualPage > this.countMaxPage) {
          if (this.countMaxPage === 0) {
            this.actualPage = 1;
          } else {
            this.actualPage = this.countMaxPage;
          }
        }
      }
      , perPageStr: function (newdata, olddata) {
        this.perPage = Number(this.perPageStr);
      }
      , perPage: function (newdata, olddata) {
        this.calculateCountPage();
        if (this.actualPage > this.countMaxPage) {
          this.actualPage = this.countMaxPage;
        }
      }
    },
    methods: {
      calculateCountPage(e){
        this.countMaxPage = Math.ceil(this.dataFiltered.length / this.perPage);
      },
      dataSort(arrayData, sortKey, sortType){
        return arrayData.sort(function (a, b) {
          const keyA = a[sortKey];
          const keyB = b[sortKey];
          if (sortType === "asc") {
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
          } else if (sortType === "desc") {
            if (keyA < keyB) return 1;
            if (keyA > keyB) return -1;
          }
          return 0;
        });
      },
      dataRange(from, count){
        const modul = this;
        let ret = [];
        for (let i = from; i < from + count; i++) {
          if (modul.dataFiltered.hasOwnProperty(i) && typeof modul.dataFiltered[i] !== "undefined") {
            ret.push(modul.dataFiltered[i])
          }
        }
        let sortKey = void 0;
        let sortType = void 0;
        Array.prototype.forEach.call(modul.headWithFilter, function (e, i) {
          if (modul.headWithFilter[i]['sortDirection'] !== void 0) {
            sortKey = e['key'];
            sortType = e['sortDirection'];
          }
        });
        if (sortKey !== void 0 && sortType !== void 0) {
          ret = modul.dataSort(ret, sortKey, sortType);
        }
        return ret;
      },
      prev(){
        if (this.actualPage > 1) {
          this.actualPage--;
        }
      },
      next(){
        if (this.actualPage < this.countMaxPage) {
          this.actualPage++;
        }
      },
      setActualPage(i){
//        console.log("1111")
        this.actualPage = i;

      },
      headRowClick(row, key){
        const modul = this;
        Array.prototype.forEach.call(modul.headWithFilter, function (e, i) {
          if (Number(key) !== Number(i)) {
//            modul.headWithFilter[i]['sortDirection'] = void 0;
            modul.$set(modul.headWithFilter[i], ['sortDirection'], void 0)

          }
        })

        if (typeof modul.headWithFilter[key]['sortDirection'] === "undefined") {
//          modul.headWithFilter[key]['sortDirection'] = "asc"
          modul.$set(modul.headWithFilter[key], ['sortDirection'], "asc")
        } else if (modul.headWithFilter[key]['sortDirection'] === "asc") {
//          modul.headWithFilter[key]['sortDirection'] = "desc"
          modul.$set(modul.headWithFilter[key], ['sortDirection'], "desc")
        } else {
//          modul.headWithFilter[key]['sortDirection'] = void 0
          modul.$set(modul.headWithFilter[key], ['sortDirection'], void 0)
        }

        console.log(row.key, modul.headWithFilter[key]['sortDirection'])


      },
      dataexport(){
        const modul = this;
        console.log(modul.dataFiltered);
        console.log(modul.head);
        const filteredExportdata = [];
        if (Array.isArray(modul.head) && Array.isArray(modul.dataFiltered)) {
          Array.prototype.forEach.call(modul.dataFiltered, function (e, i) {
            const row = {};
            Array.prototype.forEach.call(modul.head, function (e2, i2) {
              // TODO -- a fenti render-t befordítani az adatmásoláshoz, és nem a közvetlen adatot tolni ki
              row[e2.key] = e[e2.key];

            });
            filteredExportdata.push(row);
          });
        }
        console.log(filteredExportdata);
        // TODO -- excel exportot tenni ide

      },


    }
    , components: {
      InputText,
    },
  };
</script>

<style scoped>
  .colx {
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }

  .pagination {
    float: right
  }

  .pagination-extra > .page-link {
    background-color: rgba(0, 0, 0, .05);
  }

  .pl10 {
    padding-left: 20px !important;
  }

  .pl20 {
    padding-left: 20px !important;
  }

  /*.datatableWrapper{*/
  /*position: relative;*/
  /*top: 0;*/
  /*left: 0;*/
  /*}*/
  /*.datatableWrapperInner{*/
  /*overflow-x: scroll;*/
  /*width: 100%;*/
  /*position: absolute;*/
  /*left: 0;*/
  /*top: 0;*/
  /*margin: 20px;*/
  /*}*/
</style>
